import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addAthlete = async (athlete) => {
    return axios.post(`${BACKEND_URL}/athletes`, athlete);
};

export const getAllAthletes = async() => {
    return axios.get(`${BACKEND_URL}/athletes`);
};

export const getAthlete = async (email) => {
    return axios.get(`${BACKEND_URL}/athletes/${email}`);
};

export const getAthletesOfCoach = async (email) => {
    return axios.get(`${BACKEND_URL}/coaches/${email}/athletes`);
};

export const getAthletesOfNationalCoach = async () => {
    return axios.get(`${BACKEND_URL}/nationalCoach/athletes`);
};

export const getAthletesOfParent = async (email) => {
    return axios.get(`${BACKEND_URL}/parents/${email}/athletes`);
};